"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-4xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <Card className="border border-border bg-muted shadow-soft">
            <CardHeader>
              <CardTitle className="text-2xl md:text-3xl font-semibold text-foreground">
                A Unified Design-to-Completion Process
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-base leading-relaxed text-muted-foreground">
                Brighthouse Construction handles every aspect of your custom home build as a single, cohesive process. From the earliest design conversations through timber-frame construction and final completion, the owner-builder provides hands‑on management and direct communication at every phase.
              </p>
              <p className="text-base leading-relaxed text-muted-foreground">
                This unified approach eliminates handoffs, ensures thoughtful decisions, and maintains the transparency and quality you expect throughout the entire build. Whether you're considering a timber‑frame residence or a fully custom design, you work with one point of contact who takes responsibility from concept to move‑in.
              </p>
            </CardContent>
            <CardFooter>
              <Link to="https://brighthouseconstructionmaine.com/our-process/" className="inline-block">
                <Button variant="link" className="h-auto p-0 text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:text-primary-dark hover:no-underline focus-ring">
                  See How We Work
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}